import React, { Component } from 'react'
import { gotoDashboard } from '../utilities/customRoutes'
import './404.scss'

export default class ErrorPage extends Component {

    render() {
        return (
            <div className="bb-error-page d-flex flex-column justify-content-center align-items-center flex-grow-1">                
                <img className="img-fluid floating" src="/images/lostinspace.png" alt="" />
                <h2 className="mb-3">This page is lost in space.</h2>
                <button className="rounded bb-bg_primary text-white border-0 p-2" onClick={() => gotoDashboard()}>
                    Back to My Deals
                </button>
                <div className="stars"></div>
                <div className="twinkling"></div>
            </div>

        );
    }
} 